export default __webpack_public_path__ + "static/media/Foundations_8x4.256.0c9a236a.png";